module.exports = __webpack_public_path__ + "img/siren__1_@2x.e8fc89e3.png";